var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { GoalPlannerNote, GoalPlannerNoteIncludes, GoalPlannerNoteRecurrence, } from '@/models/GoalPlannerNote';
import { Group } from '@/models/Group';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ActionsMenu from '@/components/ActionsMenu/ActionsMenu.vue';
import ManageGoalPlannerNoteDialog from '@/views/Groups/Tabs/GoalPlanner/ManageGoalPlannerNoteDialog/ManageGoalPlannerNoteDialog.vue';
import DeleteRecurringNoteDialog from '@/views/Groups/Tabs/GoalPlanner/DeleteRecurringNoteDialog/DeleteRecurringNoteDialog.vue';
let GoalPlannerNotes = class GoalPlannerNotes extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.notesAction = [
            {
                icon: 'add',
                label: this.$tc('Add'),
                action: async () => {
                    this.onAddNote();
                },
                visible: true,
                disabled: false,
            },
        ];
        this.addNoteDialogIsOpen = false;
        this.selectedNote = null;
        this.isLoadingNotes = true;
        this.notes = [];
        this.deleteRecurringNoteDialogIsOpen = false;
        this.noteToDelete = null;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        await this.fetchNotes();
    }
    // #endregion
    // #region Event handlers
    onCloseDeleteRecurringNoteDialog() {
        this.deleteRecurringNoteDialogIsOpen = false;
        this.noteToDelete = null;
    }
    onCloseAddNoteDialog() {
        this.selectedNote = null;
        this.addNoteDialogIsOpen = false;
    }
    onAddNote() {
        this.addNoteDialogIsOpen = true;
    }
    onEditNote(note) {
        this.selectedNote = note;
        this.addNoteDialogIsOpen = true;
    }
    onNoteCreated() {
        this.fetchNotes();
        this.addNoteDialogIsOpen = false;
    }
    onNoteUpdated() {
        this.fetchNotes();
        this.selectedNote = null;
        this.addNoteDialogIsOpen = false;
    }
    // #endregion
    // #region Class methods
    getNoteActions(note) {
        return [
            {
                icon: 'edit',
                label: this.$tc('Edit'),
                action: () => this.onEditNote(note),
                visible: note && note.author ? this.user.id === note.author.id : false,
                disabled: false,
            },
            {
                icon: 'delete',
                label: this.$tc('Delete'),
                action: () => this.onDeleteNote(note),
                visible: note && note.author ? this.user.id === note.author.id : false,
                disabled: false,
            },
        ];
    }
    // #endregion
    // #region Async methods (api calls only)
    async fetchNotes() {
        this.isLoadingNotes = true;
        try {
            this.notes = await new GoalPlannerNote()
                .include([GoalPlannerNoteIncludes.AUTHOR])
                .filter({
                date: this.date,
            })
                .fetchGroupNotes(this.group.id);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoadingNotes = false;
        }
    }
    async onDeleteNote(note) {
        try {
            if (note.recurrence !== GoalPlannerNoteRecurrence.NONE) {
                this.deleteRecurringNoteDialogIsOpen = true;
                this.noteToDelete = note;
            }
            else {
                await new GoalPlannerNote().deleteGroupNote(this.group.id, note.id);
                await this.fetchNotes();
            }
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async deleteRecurringNoteOccurrence() {
        if (!this.noteToDelete) {
            return;
        }
        try {
            await new GoalPlannerNote().deleteGroupNote(this.group.id, this.noteToDelete.id, this.date);
            await this.fetchNotes();
            this.onCloseDeleteRecurringNoteDialog();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async deleteAllRecurringNotes() {
        if (!this.noteToDelete) {
            return;
        }
        try {
            await new GoalPlannerNote().deleteGroupNote(this.group.id, this.noteToDelete.id);
            await this.fetchNotes();
            this.onCloseDeleteRecurringNoteDialog();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters & Setters
    get hasNotes() {
        return this.notes && this.notes.length > 0;
    }
    get user() {
        return this.$store.state.Auth;
    }
    // #endregion
    // #region @Watchers
    async onDateChanged() {
        this.initialize();
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], GoalPlannerNotes.prototype, "group", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", String)
], GoalPlannerNotes.prototype, "date", void 0);
__decorate([
    Watch('date'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], GoalPlannerNotes.prototype, "onDateChanged", null);
GoalPlannerNotes = __decorate([
    Component({
        components: {
            ActionsMenu,
            ManageGoalPlannerNoteDialog,
            DeleteRecurringNoteDialog,
        },
    })
], GoalPlannerNotes);
export default GoalPlannerNotes;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
